"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDescriptorFilterEvaluationHandler = void 0;
const ajv_1 = __importDefault(require("ajv"));
const ajv_formats_1 = __importDefault(require("ajv-formats"));
const jsonpath_1 = __importDefault(require("jsonpath"));
const ConstraintUtils_1 = require("../../ConstraintUtils");
const Messages_1 = __importDefault(require("../../types/Messages"));
const utils_1 = require("../../utils");
const abstractEvaluationHandler_1 = require("./abstractEvaluationHandler");
class InputDescriptorFilterEvaluationHandler extends abstractEvaluationHandler_1.AbstractEvaluationHandler {
    constructor(client) {
        super(client);
    }
    getName() {
        return 'FilterEvaluation';
    }
    handle(pd, wrappedVcs) {
        const fields = jsonpath_1.default.nodes(pd, '$..fields[*]');
        wrappedVcs.forEach((wvc, vcIndex) => {
            this.createNoFieldResults(pd, vcIndex);
            fields.forEach((field) => {
                let inputField = [];
                if (field.value.path) {
                    inputField = utils_1.JsonPathUtils.extractInputField(wvc.internalCredential, field.value.path);
                }
                let resultFound = false;
                for (const inputFieldKey of inputField) {
                    if (this.evaluateFilter(inputFieldKey, field.value)) {
                        resultFound = true;
                        const payload = { result: Object.assign({}, inputField[0]), valid: true };
                        this.getResults().push(Object.assign({}, this.createResultObject(jsonpath_1.default.stringify(field.path.slice(0, 3)), vcIndex, payload)));
                    }
                }
                if (!resultFound) {
                    if (!inputField.length) {
                        const payload = { valid: false };
                        this.createResponse(field, vcIndex, payload, Messages_1.default.INPUT_CANDIDATE_DOESNT_CONTAIN_PROPERTY);
                    }
                    else {
                        const payload = { result: Object.assign({}, inputField[0]), valid: false };
                        this.createResponse(field, vcIndex, payload, Messages_1.default.INPUT_CANDIDATE_FAILED_FILTER_EVALUATION);
                    }
                }
            });
        });
        this.updatePresentationSubmission(pd);
    }
    createNoFieldResults(pd, vcIndex) {
        // PresentationDefinitionV2 is the common denominator
        const noFields = pd.input_descriptors
            .map((inDesc, index) => {
            return { index, inDesc };
        })
            .filter((el) => { var _a, _b, _c; return ((_a = el.inDesc.constraints) === null || _a === void 0 ? void 0 : _a.fields) === undefined || ((_c = (_b = el.inDesc.constraints) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.length) === 0; });
        noFields.forEach((noField) => {
            const payload = { result: [], ['valid']: true };
            this.getResults().push(Object.assign({}, this.createResultObject(`$.input_descriptors[${noField.index}]`, vcIndex, payload)));
        });
    }
    createResponse(field, vcIndex, payload, message) {
        this.getResults().push(Object.assign(Object.assign({}, this.createResultObject(jsonpath_1.default.stringify(field.path.slice(0, 3)), vcIndex, payload)), { ['status']: ConstraintUtils_1.Status.ERROR, ['message']: message }));
    }
    createResultObject(path, vcIndex, payload) {
        return {
            input_descriptor_path: path,
            verifiable_credential_path: `$[${vcIndex}]`,
            evaluator: this.getName(),
            status: ConstraintUtils_1.Status.INFO,
            message: Messages_1.default.INPUT_CANDIDATE_IS_ELIGIBLE_FOR_PRESENTATION_SUBMISSION,
            payload,
        };
    }
    evaluateFilter(result, field) {
        var _a;
        if (((_a = field.filter) === null || _a === void 0 ? void 0 : _a.format) && field.filter.format === 'date') {
            this.transformDateFormat(result);
        }
        const ajv = new ajv_1.default();
        (0, ajv_formats_1.default)(ajv);
        if (field.filter) {
            return ajv.validate(field.filter, result.value);
        }
        return true;
    }
    transformDateFormat(result) {
        const date = new Date(result.value);
        let month = date.getUTCMonth() + 1 + '';
        if (month.length === 1) {
            month = '0' + month;
        }
        let day = date.getUTCDate() + '';
        if (day.length === 1) {
            day = '0' + day;
        }
        result.value = date.getUTCFullYear() + '-' + month + '-' + day;
        result.value = date.toISOString().substring(0, date.toISOString().indexOf('T'));
    }
}
exports.InputDescriptorFilterEvaluationHandler = InputDescriptorFilterEvaluationHandler;
